import { Theme } from '@mui/material/styles'

const useStyles = {
  metaTag: (theme: Theme) => ({
    color: theme.palette.text.primary,
    border: '1px solid rgba(0, 0, 0, 0.05)',
    borderRadius: '50px',
    padding: theme.spacing(0, 1),
    whiteSpace: 'nowrap',
  }),
  imageContainer: (theme: Theme) => ({
    width: '114px',
    aspectRatio: 1,
    borderRadius: '100%',
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      boxShadow: theme.shadows[4],
    },
  }),
  imageAvatar: {
    height: 'calc(100% - 4px)',
    aspectRatio: 1,
    borderRadius: '100%',
  },
  imageAlertIcon: {
    position: 'absolute',
    bottom: '-5px',
    right: '-5px',
    borderRadius: '100%',
    height: '34px',
    aspectRatio: 1,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alertTableRow: (theme: Theme) => ({
    '&.MuiDataGrid-row--detailPanelExpanded': {
      backgroundColor: theme.palette.primary.shades['8p'],
      '&:hover': {
        backgroundColor: theme.palette.primary.shades['12p'],
      },
    },
  }),
  alertTablePanel: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.shades['4p'],
    padding: theme.spacing(3, 5),
  }),
  alertTableDataGrid: (theme: Theme) => ({
    border: `1px solid ${theme.palette.action.selected}`,
    borderRadius: '12px',
    backgroundColor: theme.palette.common.white,
    '& .MuiDataGrid-columnHeaders > [role=row]': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-cell': {
      padding: '13px 10px',
    },
  }),
  alertsMultilineText: {
    textWrap: 'wrap',
    overflow: 'hidden',
    height: '100%',
  },
  truncatedText: { textOverflow: 'ellipsis', width: '100%', overflowX: 'hidden' },
  tabs: (theme: Theme) => ({ marginBottom: theme.spacing(3) }),
  tab: { flex: 1 },
  searchContainer: (theme: Theme) => ({
    display: 'flex',
    gap: theme.spacing(),
    [theme.breakpoints.only('xs')]: {
      paddingTop: theme.spacing(),
    },
  }),
  searchTextField: {
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  searchTextFieldInput: (theme: Theme) => ({
    borderRadius: theme.shape.extraLargeBorderRadius,
    maxWidth: '133px',
    transition: theme.transitions.create('max-width'),
    '&.Mui-focused': {
      maxWidth: '300px',
    },
  }),
  filterButton: (theme: Theme) => ({
    borderRadius: theme.shape.extraLargeBorderRadius,
  }),
  filterMenuPaper: {
    padding: 0,
  },
}
export default useStyles
